import { Breadcrumbs, Typography } from '@material-ui/core';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import React, { CSSProperties, FC, memo, useMemo } from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { viewTexts } from '../../constants/view-texts';
import { routes } from '../../routing/routes';
import { MuiPaper } from '../shared/mui/mui-paper';

const vt = viewTexts.breadcrumbs;

const InnerWrapper = styled.div`
  padding: 5px 10px;
`;

const LinkStyled = styled(Link)`
  color: blue;
  &:hover {
    text-decoration: underline;
  }
`;

interface Props {
  links: [string, string][];
  pathLast: string;
  showPadding: boolean;
}

export const BreadcrumbsJpView: FC<Props> = memo(
  ({ links, pathLast, showPadding }: Readonly<Props>) => {
    const rootStyle = useMemo<CSSProperties>(
      () => (showPadding ? { padding: '10px 10px 5px 10px' } : {}),
      [showPadding]
    );

    return (
      <div style={rootStyle}>
        <MuiPaper elevation={0}>
          <InnerWrapper>
            <Breadcrumbs
              separator={<NavigateNextIcon fontSize='small' />}
              aria-label='Breadcrumb'
              maxItems={100}
            >
              <LinkStyled to={routes.home}>{vt.home}</LinkStyled>
              {links.map(([pathElementDisplayName, pathPrefix], idx) => (
                <LinkStyled key={idx} to={pathPrefix}>
                  {pathElementDisplayName}
                </LinkStyled>
              ))}
              <Typography color='textPrimary'>{pathLast}</Typography>
            </Breadcrumbs>
          </InnerWrapper>
        </MuiPaper>
      </div>
    );
  }
);

BreadcrumbsJpView.displayName = 'BreadcrumbsJpView';
